import type { SVGProps } from 'react'

/** The X mark, drawn in `currentColor` so it takes the surrounding text colour. */
export function XIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
      <path d="M13.65 10.9 18.1 6H17l-3.85 4.2L10.05 6H6.5l4.7 6.75L6.5 18h1.1l4.1-4.45L15 18h3.55l-4.9-7.1Zm-1.4 2-.5-.7L8 6.9h1.5l3.2 4.4.5.7 3.9 5.5h-1.5l-3.35-4.6Z" />
    </svg>
  )
}
